/** Path of the brick reference below `measurement`; the input takes its id. */
const BRICK_PATH = 'pitchedRoof.brick';
/** Belongs to the block project-measurement-report-approval, never to a card. */
const APPROVAL_NOTE_PATH = 'measurementApprovementNote';

const valueAtPath = (object, path) =>
  path.split('.').reduce((value, segment) => (value == null ? undefined : value[segment]), object);

const inputValueAt = (measurement, path) => {
  const value = valueAtPath(measurement, path);
  if (path === BRICK_PATH) {
    return value?.id ?? null;
  }
  return value ?? null;
};

/** Sets `value` at the dotted `path` of `object`, creating the objects on the way. */
const setAtPath = (object, path, value) => {
  const segments = path.split('.');
  const lastSegment = segments.pop();
  const parent = segments.reduce((current, segment) => {
    current[segment] = current[segment] ?? {};
    return current[segment];
  }, object);
  parent[lastSegment] = value;
};

const toCompletedInput = (completed) =>
  (completed ?? []).map(({ type, value }) => ({ type, value }));

/**
 * Sparse `ProjectMeasurementReportDataInput` of one card: the values at `fieldPaths` (dotted,
 * below `measurement`, e.g. `pitchedRoof.conditionState`) plus the card states `completed`. The
 * brick is sent as its id; the approval note is never sent (see feature page projekt-protokolle).
 */
export const toMeasurementCardInput = (measurement, fieldPaths) => {
  const input = {};
  fieldPaths
    .filter((path) => path !== APPROVAL_NOTE_PATH)
    .forEach((path) => setAtPath(input, path, inputValueAt(measurement, path)));
  input.completed = toCompletedInput(measurement?.completed);

  return input;
};
